import { Observable, Subscription } from 'rxjs';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, first } from 'rxjs/operators';
export interface DeleteBookingLinkConfirmationDialogData {
  confirmationCallback: () => Observable<void>;
  category: string;
}

@Component({
  selector: 'meeting-scheduler-delete-booking-link-confirmation-dialog',
  templateUrl: './delete-booking-link-confirmation-dialog.component.html',
  styleUrls: ['./delete-booking-link-confirmation-dialog.component.scss'],
  standalone: false,
})
export class DeleteBookingLinkConfirmationDialogComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription[] = [];
  working = false;
  @Input() category?: string;

  constructor(
    private readonly ref: MatDialogRef<DeleteBookingLinkConfirmationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) readonly data: DeleteBookingLinkConfirmationDialogData,
  ) {}

  categoryTitle: string;
  categoryContent: string;
  categoryDoNotDelete: string;
  categoryDoDelete: string;

  ngOnInit(): void {
    this.setCategoryTranslations(this.data.category);
  }

  setCategoryTranslations(category: string): void {
    let prefix = `MEETING_SCHEDULER.BOOKING_LINK.`;
    if (category != undefined) {
      prefix = `${prefix}${category.toUpperCase()}.`;
    }
    this.categoryTitle = `${prefix}DELETE_TITLE`;
    this.categoryContent = `${prefix}DELETE_CONTENT`;
    this.categoryDoNotDelete = `${prefix}DO_NOT_DELETE`;
    this.categoryDoDelete = `${prefix}DO_DELETE`;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onNoClick(): void {
    this.ref.close(false);
  }

  onYesClick(): void {
    this.working = true;
    this.subscriptions.push(
      this.data
        .confirmationCallback()
        .pipe(
          first(),
          finalize(() => (this.working = false)),
        )
        .subscribe({
          next: () => {
            this.ref.close(true);
          },
        }),
    );
  }
}
